export const ITPStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Inspecție Tehnică Periodică (ITP)",
  provider: {
    "@type": "Organization",
    name: "GabyLen Autoservice & ITP",
    url: "https://www.gabylenautoservice.ro/itp",
  },
  areaServed: [
    {
      "@type": "Place",
      name: "Florești, Cluj",
    },
    {
      "@type": "Place",
      name: "Cluj-Napoca, Cluj",
    },
    {
      "@type": "Place",
      name: "Gilau, Cluj",
    },
    {
      "@type": "Place",
      name: "Somesu-Rece, Cluj",
    },
    {
      "@type": "Place",
      name: "Somesu-Cald, Cluj",
    },
  ],
  description:
    "ITP pentru auto, autoutilitare si taxiuri la GabyLen Autoservice & ITP.",
  offers: [
    {
      "@type": "Offer",
      name: "ITP pentru Autovehicule",
      description: "Prețul pentru ITP a autovehiculelor.",
      priceCurrency: "RON",
      price: "200.00",
      eligibleRegion: {
        "@type": "Place",
        name: "Florești, Cluj",
      },
      url: "https://www.gabylenautoservice.ro/itp",
    },
    {
      "@type": "Offer",
      name: "ITP pentru Taxi",
      description: "Prețul pentru inspecția tehnică periodică a taxiurilor.",
      priceCurrency: "RON",
      price: "150.00",
      eligibleRegion: {
        "@type": "Place",
        name: "Florești, Cluj",
      },
      url: "https://www.gabylenautoservice.ro/itp",
    },
    {
      "@type": "Offer",
      name: "ITP pentru Autoutilitare",
      description:
        "Prețul pentru inspecția tehnică periodică a autoutilitarelor.",
      priceCurrency: "RON",
      price: "220.00",
      eligibleRegion: {
        "@type": "Place",
        name: "Florești, Cluj",
      },
      url: "https://www.gabylenautoservice.ro/itp",
    },
  ],
};
export const HomeStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "GabyLen Autoservice & ITP",
  url: "https://www.gabylenautoservice.ro",
  logo: "https://www.gabylenautoservice.ro/logo.png",
  sameAs: [
    "https://www.facebook.com/gabylenautoservice",
    "https://www.instagram.com/gabylenauto/",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Strada Porii 162",
    addressLocality: "Florești",
    addressRegion: "Cluj",
    postalCode: "407280",
    addressCountry: "RO",
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+40772006950",
      contactType: "customer service",
      areaServed: "RO",
      availableLanguage: "Romanian",
      serviceType: "ITP & Mecanica",
      description:
        "Pentru întrebări legate de ITP sau Mecanica, programări și informații specifice",
    },
    {
      "@type": "ContactPoint",
      telephone: "+400772005574",
      contactType: "customer service",
      areaServed: "RO",
      availableLanguage: "Romanian",
      serviceType: "Tinichigerie & Vopsitorie",
      description:
        "Pentru întrebări legate de tinichigerie și vopsitorie, reparații de caroserie",
    },
  ],
  description:
    "GabyLen Autoservice & ITP din Florești Cluj oferă servicii de reparații mecanice, inspecție tehnică periodică (ITP), schimb de anvelope și multe altele. Furnizăm servicii auto de înaltă calitate, susținute de o echipă profesionistă.",
  areaServed: [
    {
      "@type": "Place",
      name: "Florești, Cluj",
    },
    {
      "@type": "Place",
      name: "Cluj-Napoca, Cluj",
    },
    {
      "@type": "Place",
      name: "Gilau, Cluj",
    },
    {
      "@type": "Place",
      name: "Somesu-Rece, Cluj",
    },
    {
      "@type": "Place",
      name: "Somesu-Cald, Cluj",
    },
  ],
  openingHoursSpecification: [
    // ITP Schedule (Mon - Fri, 08:00 - 16:00)
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Monday",
      opens: "08:00",
      closes: "16:00",
      serviceType: "ITP",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Tuesday",
      opens: "08:00",
      closes: "16:00",
      serviceType: "ITP",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Wednesday",
      opens: "08:00",
      closes: "16:00",
      serviceType: "ITP",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Thursday",
      opens: "08:00",
      closes: "16:00",
      serviceType: "ITP",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Friday",
      opens: "08:00",
      closes: "16:00",
      serviceType: "ITP",
    },

    // Mecanica Schedule (Mon - Fri, 09:00 - 17:00)
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Monday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Mecanica",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Tuesday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Mecanica",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Wednesday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Mecanica",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Thursday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Mecanica",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Friday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Mecanica",
    },

    // Tinichigerie Schedule (Mon - Fri, 09:00 - 17:00)
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Monday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Tinichigerie & Vopsitorie",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Tuesday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Tinichigerie & Vopsitorie",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Wednesday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Tinichigerie & Vopsitorie",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Thursday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Tinichigerie & Vopsitorie",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Friday",
      opens: "09:00",
      closes: "17:00",
      serviceType: "Tinichigerie & Vopsitorie",
    },
  ],
};
